import { useContext } from "react";
import { AnalyticsContext } from "./analyticsContextValue";

export const useAnalyticsContext = () => {
  return useContext(AnalyticsContext);
};
